import React from 'react';


function blogListingPage (props) {
 
return (

  

		<div className="col-xs-12 productListing">
    <h2>{props.blog.blogName}</h2>
    <img src={props.blog.blogMainImage} alt= {props.blog.blogName} width="230" height="250"/><p></p>
           <button type="button" className="btn btn-success "> <a className="go-to-store-button-link" href={`/blog/${props.blog.blogURL}`}>View Product</a> </button> 

		</div>      

    
    );
}

export default blogListingPage;